import request from './index'

const api = {
	//顶部菜单
	siteMenu(){
		return request({
			url: '/api/site/menues',
			method: 'get'
		})
	},

	//首页
	indexCollect(){
		return request({
			url: `/api/index/collect`,
			method: 'get'
		})
	},
	
	//关于我们-董事长简介
	aboutLeaderInfo(){
		return request({
			url: `/api/about/leader-info`,
			method: 'get'
		})
	},
	
	//关于我们-办学规划
	aboutSchoolProject(){
		return request({
			url: `/api/about/school-project`,
			method: 'get'
		})
	},
	
	//关于我们-发展历程
	aboutSchoolHistory(){
		return request({
			url: `/api/about/school-history`,
			method: 'get'
		})
	},
	
	//关于我们-荣誉资质
	aboutSchoolHonour(){
		return request({
			url: `/api/about/school-honour`,
			method: 'get'
		})
	},

	//关于我们-合作办学
	businessCollect(){
		return request({
			url: '/api/business/collect'
		})
	},

	//关于我们-办学管理规划-新
	aboutSchoolProjectRicetext(){
		return request({
			url : '/api/morph/show/school-project'
		})
	},
	
	//新闻中心-新闻列表
	news(params){
		return request({
			url: `/api/news`,
			method: 'get',
			params
		})
	},
	
	//新闻中心-新闻详情
	newsDetail(params){
		return request({
			url: `/api/news/show`,
			method: 'get',
			params
		})
	},

	//办学目标-教育体系
	educationSystem(){
		return request({
			url: '/api/education/system'
		})
	},
	
	//办学目标-教育理念
	educationLife(){
		return request({
			url: '/api/education/life'
		})
	},
	
	//办学目标-特色教育
	educationFeature(){
		return request({
			url: '/api/education/feature'
		})
	},
	
	//办学目标-园本教材
	educationBook(){
		return request({
			url: '/api/education/book'
		})
	},
	
	//家园共育-入园须知分类
	schoolRuleCategory(){
		return request({
			url: '/api/category/school-rule'
		})
	},
	
	//家园共育-入园须知
	schoolRule(params){
		return request({
			url: '/api/school-rule',
			params
		})
	},
	
	//家园共育-入园流程
	schoolFlow(){
		return request({
			url: '/api/school/flow'
		})
	},
	
	//家园共育-行为规范
	schoolActionRule(){
		return request({
			url: '/api/school/action-rule'
		})
	},
	
	//家园共育-一日作息
	schoolOnedayFlow(){
		return request({
			url: '/api/school/oneday-flow'
		})
	},
	
	//家园共育-应知应做
	schoolTodoList(){
		return request({
			url: '/api/school/todo-list'
		})
	},
	
	//家园共育-家长感言
	schoolParentComment(){
		return request({
			url: '/api/school/parent-comment'
		})
	},
	
	//加入我们-成长之路
	joinGrowUp(){
		return request({
			url: '/api/join/grow-up'
		})
	},
	
	//加入我们-星语星愿
	joinWish(){
		return request({
			url: '/api/join/wish'
		})
	},
	
	//加入我们-校园招聘
	joinSchoolJob(params){
		return request({
			url: '/api/join/school-job',
			params
		})
	},
	
	//加入我们-社会招聘
	joinSocietyJob(params){
		return request({
			url: '/api/join/society-job',
			params
		})
	},
	
	//国际幼儿园-新闻
	interntNews(params){
		return request({
			url: '/api/internet/news',
			params
		})
	},

	//国际幼儿园-新闻-详情
	interntNewsDetail(params){
		return request({
			url: '/api/internet/news/show',
			params
		})
	},

	//国际幼儿园-招生资讯
	interntJoinInfo(params){
		return request({
			url: '/api/internet/join-info',
			params
		})
	},

	//国际幼儿园-招生资讯详情
	interntJoinInfoDetail(params){
		return request({
			url: '/api/internet/join-info/show',
			params
		})
	},	
	
	//国际幼儿园-其他
	interntCollect(params){
		return request({
			url: '/api/internet/collect',
			params
		})
	},
	
	//四叶草艺术培训中心
	cloverCollect(params){
		return request({
			url: '/api/clover/collect',
			params
		})
	},

	//幼童军
	armyCollect(params){
		return request({
			url: '/api/army/collect',
			params
		})
	},
	
	//园所查找-省
	areaProvince(params){
		return request({
			url: '/api/area/province',
			params
		})
	},
	
	//园所查找-市
	areaCity(params){
		return request({
			url: '/api/area/city',
			params
		})
	},
	
	//园所查找-园所列表
	areaSchools(params){
		return request({
			url: '/api/schools',
			params
		})
	},

	//园所查找-园所详情
	areaSchoolsDetail(params){
		return request({
			url: 'api/schools/show',
			params
		})
	},

	//专业合作
	businessPro(){
		return request({
			url: '/api/business-pro'
		})
	},

	//联系我们
	contactUs(){
		return request({
			url: '/api/contact-us'
		})
	},
}
export default api



// WEBPACK FOOTER //
// ./src/api/api.js